module.exports = __webpack_public_path__ + "img/upload-icon.34608660.svg";